<template>
<div>
    <pencilbutton  @click="startUpdateInitialBalance()" :disabled="disableAddFunds" />
    <!-- <linkbutton toplabel="Update Initial Balance" @click="startUpdateInitialBalance()" :disabled="disableAddFunds"/> -->
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Set Initial Account Balance for {{AdminFundRequest.Name}}</label>
                <br/>
                
                <label class="mediumtext" >Old Initial Amount: {{AdminFundRequest.oldAmount | toCurrency}}</label>
                <formentry inputid="newamount" inputtype="number"  :isrequired='trueParam' label="Updated Initial Balance $"  v-model="AdminFundRequest.newAmount"  />
                <formentry inputid="reason"  label="Reason"  v-model="AdminFundRequest.Reason" :isrequired='trueParam' />
                <div>
                <label  class="required">{{requiredFieldLabel}}</label>
                </div>
                <smallbutton  @click="ConfirmInitialBalance()" toplabel="Save"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import pencilbutton from '../controls/pencilbutton.vue'
export default {
    name:'updateinitialbalance',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton
    },
    props:{
        account:{
            type:Object,
            required:true
        }
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            
            responseMessage:'',
            pleaseWait:false,

            AdminFundRequest:{
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:''
            },
            trueParam:true
            
        }
    },
    computed:{
        ...mapFields([
            'disableAddFunds',

        ]),
        
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        startUpdateInitialBalance(){

      
            this.AdminFundRequest={
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:''
            }        
            this.AdminFundRequest.oldAmount=this.account.initialBalance.toString();
            this.AdminFundRequest.Name=this.account.Name;
            this.AdminFundRequest.fromAccount=this.account.ID;
            this.$refs.mymodal.openModal()
            this.responseMessage=''
        },
        async ConfirmInitialBalance(){
            if(this.$refs.balform.checkValidity()){
                 this.beforeAPI();
                  let req = {
                    adminfunds:this.AdminFundRequest,
                }
                var response = await this.callAPI(req,'initialbalance')

                if(response.Successful){
                    this.responseMessage="Update Inital Balance was successful"
                    this.$emit('refresh')
                }else{
                this.message = response.Message
                }
                this.pleaseWait=false;
            }
         },
       
        
    }
}
</script>

<style>

</style>





























